'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogRegistration = require('./remote/catalogRegistration');

var CatalogRegistation = {
    fetchCatalogRegistration: _catalogRegistration.CatalogRegistrationRemote.fetchCatalogRegistration
};

exports.default = CatalogRegistation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogRegistration.js
// module id = rj0E
// module chunks = 57